import React from "react";

import {
    Grid,
    IconButton,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import { GridToolbarContainer } from "@mui/x-data-grid-pro";

import {
    createStringDataField,
    createTimestampField
} from "../../../../util/format";
import { StringEquators } from "../../../../store/constants/pages";
import CloseIcon from "@mui/icons-material/Close";

import { XClientDataGrid } from "../../../../common";

export const AssignedRCMTeamsHistory = ({
    openPtr,
    handleClose,
    isPending,
    assignedClaimData,
    reload,
}) => {
    function handleRefresh() {
        reload();
    }

    const fields = [
        createTimestampField("updatedAt", "Updated At", { sortable: true }),

        createStringDataField("updatedBy", "Updated By", {
            sortable: true,
            equators: StringEquators,
        }),
            createStringDataField("rcmTeamName", "New Value", {
            equators: StringEquators,
        }),
    ];

    return (
        <Dialog
            open={openPtr.value}
            onClose={handleClose}
            fullWidth
            sx={{
                "& .MuiPaper-root": {
                    maxHeight: "570px",
                },
            }}
            maxWidth="md"
        >
            <DialogTitle>
                <Grid container alignItems="center">
                    <Grid item xs={10}>
                        <Typography variant="h6">RCM Teams History</Typography>
                    </Grid>
                    <Grid item xs={2} className="text-right">
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            size="large"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <XClientDataGrid
                    fields={fields}
                    data={assignedClaimData || []}
                    // sortPtr={sortPtr}
                    loading={isPending != null}
                    hideFooter
                    slots={
                        {
                            toolbar: Toolbar,
                        } as any
                    }
                    slotProps={{
                        toolbar: {
                            handleRefresh,
                        } as any,
                    }}
                />
            </DialogContent>
        </Dialog>
    );
};

const Toolbar = ({ handleRefresh }) => (
    <GridToolbarContainer>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton onClick={handleRefresh}>
            <RefreshIcon />
        </IconButton>
    </GridToolbarContainer>
);
